var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFooter = function SvgFooter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257.18 339.86",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea5504;}.cls-2{fill:#ed6c00;}.cls-3{fill:#f08300;}.cls-4{fill:#f39800;}.cls-5{fill:#f6ab00;}.cls-6{fill:#fabe00;}.cls-7{fill:#fdd000;}.cls-8{fill:#404040;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u30A2\u30BB\u30C3\u30C8 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 167.94 67.18 235.1 67.18 100.77 0 167.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.19 100.77 134.34 33.59 0 33.59 67.19 100.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 167.94 0 235.1 67.18 235.1 0 167.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "257.18 235.1 209.68 187.6 162.19 235.1 257.18 235.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 33.59 0 167.94 67.19 100.77 0 33.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "100.76 67.18 235.1 67.18 167.92 0.01 100.76 67.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "187.6 114.68 187.6 162.19 235.1 114.68 187.6 114.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "162.19 187.61 162.19 235.1 209.68 187.6 162.19 187.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "187.6 67.18 187.6 114.68 235.1 114.67 235.1 67.19 187.6 67.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.69,
    y: 140.11,
    width: 47.5,
    height: 47.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "114.69 140.11 67.2 187.6 114.68 187.61 114.69 140.11 114.69 140.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "209.68 187.6 162.19 140.11 162.19 187.6 209.68 187.6 209.68 187.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "100.76 0 100.76 0 33.59 0 0 33.58 67.16 33.59 100.76 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "167.92 0.01 167.92 0.01 100.76 0.01 67.16 33.59 134.34 33.59 167.92 0.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.62,290.58c0-12.33-8.53-20.6-21.2-20.6H2.2v69.31H13.88V310.82h11l13.77,28.47H52.19L37,309.05C44.9,306.38,49.62,299.54,49.62,290.58Zm-21.93,9.76H13.88V281H27.69c6.32,0,10.24,3.73,10.24,9.74S34,300.34,27.69,300.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.17,269.41a23.87,23.87,0,0,0-17.81,7.48c-6.58,6.81-6.58,14.48-6.58,27.2v1.09c0,12.71,0,20.39,6.58,27.2a25.06,25.06,0,0,0,35.72,0c6.5-6.71,6.5-14.24,6.5-26.69v-2.11c0-12.46,0-20-6.5-26.69A24,24,0,0,0,93.17,269.41Zm9.1,55.6a12.59,12.59,0,0,1-18.18,0c-3-3.36-3.62-7-3.62-20.37s.65-17,3.62-20.37a12.52,12.52,0,0,1,18.18,0c3,3.34,3.62,7,3.62,20.37S105.24,321.65,102.27,325Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "248.13 280.95 248.13 269.98 204.56 269.98 204.56 339.29 248.13 339.29 248.13 328.31 216.24 328.31 216.24 309.78 241.94 309.78 241.94 298.91 216.24 298.91 216.24 280.95 248.13 280.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M174,317.22c-.5,3.86-1.44,5.88-3.13,7.79a12.58,12.58,0,0,1-18.17,0c-3-3.36-3.63-7-3.63-20.37s.64-17,3.63-20.37a12.51,12.51,0,0,1,18.17,0c1.64,1.85,2.57,3.78,3.08,7.43h11.92c-.55-6-2.06-10.55-6.19-14.81a25.06,25.06,0,0,0-35.72,0c-6.58,6.81-6.58,14.48-6.58,27.2v1.09c0,12.71,0,20.39,6.58,27.2a25.06,25.06,0,0,0,35.72,0c4.2-4.34,5.68-9,6.2-15.16Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/footer.3fabc4451caba529193428bb74f50b11.svg";